/* NILO V5.13.41 — category safety, diversity buffer and compact page flow.
   No changes to checkout, product forms, wishlist or tracking. */
(function(){
 'use strict';
 if(window.__niloStability51341)return;window.__niloStability51341=true;
 function ready(){
  // Never leave empty category tiles showing a decorative "n" in the shopping rail.
  var home=document.querySelector('[data-nilo-app-home]');
  if(home){home.querySelectorAll('.nilo-category-rail [data-nilo-home-category]').forEach(function(tile){
    var media=tile.querySelector('.nilo-category-v3__media');if(!media)return;
    function valid(){return !!media.querySelector('img[src],img[srcset]');}
    if(!valid())tile.hidden=true;
    media.addEventListener('error',function(e){if(e.target&&e.target.tagName==='IMG')tile.hidden=true;},true);
  });}
  // Put compact, relevant SEO / category links at the end of curated home rails,
  // ahead of the fully paginated feed instead of interrupting the initial shopping experience.
  var seo=document.querySelector('.nilo-seo-home-v56'),smart=document.querySelector('[data-nilo-smart-home]');
  if(seo&&smart&&!window.Shopify?.designMode){smart.insertAdjacentElement('afterend',seo);}
  // A very long empty Liquid rail can otherwise create a blank area before hydration.
  document.querySelectorAll('[data-nilo-smart-section][data-nilo-initially-empty="1"]').forEach(function(sec){if(!sec.querySelector('.nilo-product-card'))sec.hidden=true;});
  setupDiversity();
 }
 function setupDiversity(){
  var engine=window.NiloMerchV51341,core=window.NiloCatalogueCore;
  var section=document.querySelector('[data-nilo-infinite-section][data-nilo-preserve-order]');
  if(!engine||!core||!section||!document.querySelector('[data-nilo-app-home]'))return;
  var grid=section.querySelector('[data-nilo-infinite-items]');if(!grid)return;
  var started=false;
  function diversify(){
   if(started)return;started=true;
   var base=engine.source('/collections/all'),key='home-grid-'+String(document.documentElement.dataset.niloRefreshSeed||'');
   engine.fetchPage(base,1).then(async function(first){
    var total=first.pages;if(total<2)return;
    var pages=[2+(engine.hash(key+'a')%(total-1))];
    if(total>3){var b=2+(engine.hash(key+'b')%(total-1));if(b===pages[0])b=2+((b-1)%(total-1));pages.push(b);}
    if(total>4){var c=2+(engine.hash(key+'c')%(total-1));while(pages.indexOf(c)>=0)c=2+((c-1)%(total-1));pages.push(c);}
    var source=[];
    for(var i=0;i<pages.length;i++)try{source=source.concat((await engine.fetchPage(base,pages[i])).cards);}catch(e){}
    if(!source.length)return;
    var tmp=document.createElement('div'),existing=Array.prototype.slice.call(grid.children).filter(function(n){return !!engine.card(n);});
    var used=new Set(existing.map(engine.handle)),oldFamilies=new Set(existing.slice(0,36).map(engine.family));
    var candidates=engine.order(source,key+'shuffled').map(function(html){tmp.innerHTML=html;var c=tmp.querySelector('.nilo-product-card');return c?c.cloneNode(true):null;}).filter(function(c){var h=engine.handle(c),img=c&&c.querySelector('.nilo-product-card__media img');return !!(h&&!used.has(h)&&img&&(img.getAttribute('src')||img.getAttribute('srcset')));});
    var picked=[],families=new Set();
    candidates.forEach(function(c){var f=engine.family(c);if(picked.length>=50||!f||families.has(f)||oldFamilies.has(f))return;families.add(f);used.add(engine.handle(c));picked.push(c);});
    if(picked.length<5){candidates.forEach(function(c){var f=engine.family(c),h=engine.handle(c);if(picked.length>=50||!f||families.has(f)||used.has(h))return;families.add(f);used.add(h);picked.push(c);});}
    if(picked.length<3)return;
    // Avoid a scroll jump: this only rearranges the grid if the customer has
    // not yet passed its first viewport.
    if(grid.getBoundingClientRect().top<-window.innerHeight*0.5)return;
    var original=Array.prototype.slice.call(grid.children),head=original.slice(0,60),cards=head.filter(function(n){return !!engine.card(n);}),extras=head.filter(function(n){return !engine.card(n);});
    if(!cards.length)return;
    var recent=[];document.querySelectorAll('[data-nilo-smart-rail] .nilo-product-card').forEach(function(c){recent.push(engine.family(c));});
    var spread=core.spread(cards.concat(picked),engine.family,recent.slice(-10),10,8);
    // Preserve editorial shopping inserts rather than accidentally losing them.
    var out=document.createDocumentFragment(),at=0;
    spread.forEach(function(node,i){out.appendChild(node);if((i===7||i===15)&&extras[at])out.appendChild(extras[at++]);});
    extras.slice(at).forEach(function(n){out.appendChild(n);});
    var anchor=head.length<original.length?original[head.length]:null;
    grid.insertBefore(out,anchor);
    grid.dataset.niloDiverseV51341='1';
  }).catch(function(){/* The already-rendered catalogue stays accessible. */});
  }
  if('IntersectionObserver' in window){var observer=new IntersectionObserver(function(es){if(es.some(function(e){return e.isIntersecting;})){observer.disconnect();diversify();}},{rootMargin:'1100px 0px'});observer.observe(grid);}else diversify();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
})();
